import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import ProductLine from '@afosto/app-components-react/ProductLine';
import ItemPosition from './ItemPosition';
import ItemQuantity from './ItemQuantity';

const PutawayHistoryItem = ({ item }) => (
  <Grid item xs={12}>
    <Card>
      <Box p={2} display="flex" alignItems="center">
        <Box flex={1}>
          <ProductLine item={item} />
        </Box>
        <Hidden implementation="js" smDown>
          <Box display="flex">
            <ItemQuantity quantity={item?.quantity} />
            <ItemPosition position={item?.position} />
          </Box>
        </Hidden>
      </Box>
      <Hidden implementation="js" mdUp>
        <Box display="flex">
          <ItemQuantity quantity={item?.quantity} />
          <ItemPosition position={item?.position} />
        </Box>
      </Hidden>
    </Card>
  </Grid>
);

PutawayHistoryItem.propTypes = {
  item: PropTypes.object.isRequired,
};

export default PutawayHistoryItem;
